import React from "react";
import { Box, Skeleton, Divider, Stack, List, ListItem, ListItemAvatar, ListItemText, Avatar } from "@mui/material";

const SkeletonList = ({ count = 6 }) => {
  return (
    <List sx={{ width: "100%", bgcolor: "background.paper" }}>
      {[...Array(count)].map((_, index) => (
        <Box key={index}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <Skeleton variant="circular" width={40} height={40} />
            </ListItemAvatar>

            <ListItemText
              primary={<Skeleton variant="text" width="60%" height={22} />}
              secondary={
                <Stack spacing={0.5}>
                  <Skeleton variant="text" width="80%" height={18} />
                  <Skeleton variant="text" width="50%" height={16} />
                </Stack>
              }
            />

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Skeleton variant="rounded" width={80} height={28} />
              <Skeleton variant="circular" width={24} height={24} />
            </Box>
          </ListItem>
          {index < count - 1 && <Divider variant="inset" component="li" />}
        </Box>
      ))}
    </List>
  );
};

export default SkeletonList;
